/** @format */

import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import { INavBarProps } from "./NavBar.types";
import { UserOutlined } from "@ant-design/icons";
import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

interface IProps {
	isLoggedIn: INavBarProps["isLoggedIn"];
	onClickLogOut: ButtonProps["onClick"];
}

const NavBarView: React.FC<IProps> = ({ isLoggedIn, onClickLogOut }) =>
	isLoggedIn ? (
		<div
			style={{
				width: "100%",
				height: "50px",
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				backgroundColor: "#001628",
				paddingLeft: "10px",
			}}>
			<div key="1" style={{ backgroundColor: "transparent" }}>
				<Link to="/">
					<img
						src={require("../../assets/Logo/logo.png")}
						alt="vg-logo"
						className="vg-logo"
					/>
				</Link>
			</div>
			{/* <Menu.Item key="2" style={{ backgroundColor: "transparent" }}>
        <Link to="/">
          <Icon type="idcard" />
          <span>Accounts</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="3" style={{ backgroundColor: "transparent" }}>
        <Link to="/phone-numbers">
          <Icon type="phone" />
          <span>Phone Numbers</span>
        </Link>
      </Menu.Item> */}
			<div key="4" style={{ float: "right" }}>
				<Button onClick={onClickLogOut} type="link">
					<UserOutlined />
					Log out
				</Button>
			</div>
		</div>
	) : (
		<div />
	);

export default NavBarView;
